import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ExcelService } from './excel.services'
import { RouterModule } from '@angular/router'
import { FormsModule } from '@angular/forms'
import { routes } from './user-management.routes'
// import { DropDownsModule } from '@progress/kendo-angular-dropdowns'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { HttpRequestInterceptor } from '../interceptor/http-request-interceptor'
import { UserComponent } from './components/user.component'
import { ValidationModule } from '../validations/validation.module'
import { StateGateway } from '../common/gateways/state-gateway'
import { NetworkStateGateway } from '../common/gateways/network-state-gateway'
import { BackGroundCheckGateway } from './gateways/background-check-gateway'
import { NetworkBackGroundCheckGateway } from './gateways/network-background-check-gateway'
import { NetworkTrainingStateGateway } from './gateways/network-training-state-gateway'
import { TrainingStateGateway } from './gateways/training-state-gateway'
import { TrainingStateListComponent } from './components/training-status/training-state-list.component'
import { UserCommentsComponent } from './components/user-comments/user-comments.component'
import { NetworkUserCommentsGateway } from './gateways/network-user-comments-gateway'
import { UserCommentsGateway } from './gateways/user-comments-gateway'
import { PortalCommonModule } from '../common/portal-common.module'
import { UserListService } from './components/user-list/user-list.service'

//import { AddressGroupComponent } from '../common/components/address-group/address-group.component'
import { BusinessAndResidentialAddressComponent } from '../common/components/address-group/business-and-residential-address.component'
import { UserManagementLayoutComponent } from './components/layout/user-management-layout.component'
import { BackGroundCheckComponent } from './components/background-check/background-check.component'
import { UserProfileComponent } from './components/profile-details/user-profile-component'
import { UserProfileGateway } from './gateways/user-profile-gateway'
import { NetworkUserProfileGateway } from './gateways/network-user-profile-gateway'
import { UserGateway } from './gateways/user-gateway'
import { NetworkUserGateway } from './gateways/network-user-gateway'
import { UserPersonalDetailsComponent } from './components/personal-details/user-personal-details-component'
import { PasswordResetComponent } from './components/password-reset/password-reset.component'
import { UserListGateway } from './gateways/user-list-gateway'
import { NetworkUserListGateway } from './gateways/network-user-list-gateway'
import { UserListComponent } from './components/user-list/user-list.component'
import { CommissionLevelGateway } from './gateways/commission-level-gateway'
import { NetworkCommissionLevelGateway } from './gateways/network-commission-level-gateway'
import { UserTypeGateway } from './gateways/user-type-gateway'
import { NetworkUserTypeGateway } from './gateways/network-user-type-gateway'
import { UserTrainingDetailsComponent } from './components/user-training-details/user-training-details-component'
import { LicenseApptComponent } from './components/license-appt/license-appt.component'
import { LicenseApptGateway } from './gateways/license-appt-gateway'
import { NetworkLicenseCheckGateway } from './gateways/network-license-appt-gateway'
import { CommonGateway } from '../common/gateways/common-gateway'
import { NetworkCommonGateway } from '../common/gateways/network-common-gateway'
import { UserDataService } from './gateways/common-data-service'

import { NetworkOrganizationGateway } from '../org-management/gateways/network-organization-gateway'
import { OrgLevelGateway } from '../org-management/gateways/organization-gateway'
import { LicenseDataService } from './gateways/license-data-service'
import { UpdatePasswordComponent } from './components/update-password/update-password.component'
import { ConfirmProfileSetPasswordComponent } from './components/common/confirm-profile-set-password.component'

import { UpdateEmailComponent } from './components/update-email/update-email.component'
import { UpdateCellphonenoComponent } from './components/update-CellPhoneNo/update-cellphoneno.component'

import { TrainingCoursesList } from './components/training-courses-list/training-courses-list.component'
import { TrainingReviewComponent } from './components/training-review/training-review.component'
import { IsSuperAdminOrGuruAdminGuard } from '../auth/is-super-admin-or-guru-admin-guard'
import { LicenseLoginComponent } from './components/license-after-login/license-component'
import { UserProfileTrainingCertificateGateway } from './gateways/user-profile-training-certificate-gateway'
import { NetworkUserProfileTrainingCertificateGateway } from './gateways/network-user-profile-training-certificate-gateway'
import { DateFormatPipe } from '../common/pipes/date-format-pipe'
import { OnlyDateFormatPipe } from '../common/pipes/only-date-Format'

import { NetworkCurrentUserGateway } from '../common/gateways/network-current-user-gateway'
import { CurrentUserGateway } from '../common/gateways/current-user-gateway'

// import { NetworkSettingGateway } from '../org-management/gateways/network-setting-gateway'
import { EditFmoGateway } from '../org-management/gateways/edit-fmo-gateway'
import { EditFmoAbstractGateway } from '../org-management/gateways/edit-fmo-abstract-gateway'
import { SharedModule } from '../shared/shared.module'
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading'
import { UploadAppointmentsComponents } from '././components/Upload-Appointments/Upload-Appointments.component'
import { FileUploadModule } from 'ng2-file-upload'
import { GetExcel } from './get.excel'
import { JqxGridVirtualPaging } from '../common/utilclasses/jqxgrid-virtualpaging'
import { UserSearchComponent } from './components/user-search/user-search.component'
import { UserSearchDetailComponent } from './components/user-search/user-details.component'
import { UserDetailTrainingComponent } from './components/user-search/user-detail-training.component'
import { NEJEAddProfileComponent } from './components/neje/add-profile/add-profile.component'

import { UserListVerOneComponent } from './components/user-list/user-list-ver-one.component'
import { ReportsModule } from '../reports/reports.module'
import { NetworkMfaGateway } from './gateways/network-mfa-gateway'
import { MfaGateway } from './gateways/mfa-gateway'

@NgModule({
    declarations: [
        UserManagementLayoutComponent,
        UserComponent,
        BackGroundCheckComponent,
        UserCommentsComponent,
        UserListComponent,
        UserListVerOneComponent,
        UserSearchComponent,
        UserSearchDetailComponent,
        UserDetailTrainingComponent,
        TrainingStateListComponent,
        UserProfileComponent,
        UserPersonalDetailsComponent,
        PasswordResetComponent,
        UpdatePasswordComponent,
        UpdateEmailComponent,
        UpdateCellphonenoComponent,
        UserTrainingDetailsComponent,
        LicenseApptComponent,
        // AddressGroupComponent,
        BusinessAndResidentialAddressComponent,
        ConfirmProfileSetPasswordComponent,
        TrainingCoursesList,
        TrainingReviewComponent,
        LicenseLoginComponent,
        DateFormatPipe,
        OnlyDateFormatPipe,
        UploadAppointmentsComponents,
        NEJEAddProfileComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        ValidationModule,
        //  DropDownsModule,
        PortalCommonModule,
        SharedModule,
        FileUploadModule,
        ReportsModule,
        NgxLoadingModule.forRoot({
            animationType: ngxLoadingAnimationTypes.threeBounce,
            backdropBackgroundColour: 'rgba(0,0,0,.06)',
            primaryColour: 'red',
            secondaryColour: 'green',
            tertiaryColour: 'yellow'
        }),
        RouterModule.forChild(routes)
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
        { provide: BackGroundCheckGateway, useClass: NetworkBackGroundCheckGateway },
        { provide: UserCommentsGateway, useClass: NetworkUserCommentsGateway },
        { provide: UserProfileGateway, useClass: NetworkUserProfileGateway },
        { provide: UserGateway, useClass: NetworkUserGateway },
        { provide: StateGateway, useClass: NetworkStateGateway },
        { provide: UserGateway, useClass: NetworkUserGateway },
        { provide: UserListGateway, useClass: NetworkUserListGateway },
        { provide: CommissionLevelGateway, useClass: NetworkCommissionLevelGateway },
        { provide: UserTypeGateway, useClass: NetworkUserTypeGateway },
        { provide: TrainingStateGateway, useClass: NetworkTrainingStateGateway },
        { provide: CommonGateway, useClass: NetworkCommonGateway },
        { provide: LicenseApptGateway, useClass: NetworkLicenseCheckGateway },
        { provide: OrgLevelGateway, useClass: NetworkOrganizationGateway },
        { provide: LicenseDataService, useClass: LicenseDataService },
        { provide: CurrentUserGateway, useClass: NetworkCurrentUserGateway },
        { provide: UserProfileTrainingCertificateGateway, useClass: NetworkUserProfileTrainingCertificateGateway },
        IsSuperAdminOrGuruAdminGuard,
        { provide: LicenseDataService, useClass: LicenseDataService },
        { provide: CurrentUserGateway, useClass: NetworkCurrentUserGateway },
        { provide: EditFmoAbstractGateway, useClass: EditFmoGateway },
        { provide: UserDataService, useClass: UserDataService },
        { provide: MfaGateway, useClass: NetworkMfaGateway },
        GetExcel,
        ExcelService,
        UserListService,
        JqxGridVirtualPaging,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class UserManagementModule {}
